
<template>
    
        <mars-view class="experthome-popup-bottom"><mars-image class="experthome-popup-bottom-pic" src="https://youjia.cdn.bcebos.com/image/lvlin-logo.png" alt></mars-image><mars-view class="experthome-popup-bottom-line"></mars-view><mars-view class="experthome-popup-bottom-text">百度旗下专业法律服务平台</mars-view></mars-view>
    
</template>

<script>
export default {};
</script>

<style scoped>
.experthome-popup-bottom {
  height: 43px;
  display: flex;
  align-items: flex-end;
  border-top: 1px solid #eee;
  margin: 0 0 31px;
  justify-content: center;
}
.experthome-popup-bottom .experthome-popup-bottom-pic {
  width: 32px;
  height: 15px;
}
.experthome-popup-bottom .experthome-popup-bottom-line {
  width: 1px;
  height: 14px;
  background: #ddd;
  border-radius: 8px;
  margin: 0 11px;
}
.experthome-popup-bottom .experthome-popup-bottom-text {
  height: 15px;
  line-height: 15px;
  color: #858585;
}

</style>
